module.exports = __webpack_public_path__ + "assets/img/61@3x.2aec823b.png";